import { createSlice } from "@reduxjs/toolkit";
import { showShift } from "../actions";

const initialState = {
  shift: [],
};

const shiftSlice = createSlice({
  name: "shift",
  initialState,
  reducers: {},
  extraReducers: {
    [showShift.fulfilled]: (state, action) => {
      state.shift = action.payload || [];
    },
  },
});

export const responseShift = (state) => state.shift;

export default shiftSlice.reducer;
